import { Suspense, lazy } from "react";
import AppInitializer from "./components/AppInitializer";
import type { FunctionComponent } from "react";
import { LOGIN_PROVIDER } from "./config";

const OktaApp = lazy(() => import("./providers/OktaApp"));
const NextologiesApp = lazy(() => import("./providers/NextologiesApp"));

const App: FunctionComponent = () => {
  const isNextologies = LOGIN_PROVIDER === "nextologies";

  return (
    <AppInitializer>
      <Suspense fallback={null}>
        {isNextologies ? <NextologiesApp /> : <OktaApp />}
      </Suspense>
    </AppInitializer>
  );
};

export default App;
